import PubSub from "underpub-js";

var ListingFeatures = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingFeatures',
	};

	$.extend(true, this.options, options);

};

ListingFeatures.prototype.init = function() {

	var self = this;

};

export default ListingFeatures;
